<template>
  <div>

    <div class="row mb-3">
      <Period-Selector/>
    </div>

    <div class="row">

      <div class="col-xl-3 col-md-6">
        <Invoices-Pending-MiniCard/>
      </div>

      <div class="col-xl-3 col-md-6">
        <Invoices-Paid-MiniCard/>
      </div>

    </div>

    <el-tabs v-model="activeTab" @tab-click="updateRendering()">
      <el-tab-pane class="row" label="Invoices" name="Invoices">
        <Invoices-Card class="col-12"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'Invoices',
  data () {
    return {
      activeTab: 'Invoices'
    }
  }
}
</script>

<style>

</style>